import { render, staticRenderFns } from "./divider-tertiary.vue?vue&type=template&id=f778d9c8&scoped=true&"
import script from "./divider-tertiary.vue?vue&type=script&lang=js&"
export * from "./divider-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f778d9c8",
  null
  
)

export default component.exports